import React from "react";
import { Link } from "react-router-dom";

const LessonListItem = ({ hw }) => {
  const date = new Date(hw.lessonDate); // 2009-11-10
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "short" });
  const newDate = day + ". " + " " + month + " " + year;

  return (
    <div className='container-test'>
      <div className='naloga-container'>
        <p>{newDate}</p>

        <div>{hw.lesson} učna ura</div>

        <Link to={"/naloge/" + hw.id}>
          <button className='naloga-button'>Vstopi</button>
        </Link>
      </div>
    </div>
  );
};

export default LessonListItem;
